import { Affix } from 'antd';
import classNames from 'classnames';
import { Fragment } from 'react';
import IconCheck from './IconCheck';
import IconHeader from './IconHeader';
import UserService from '../../services/UserService';
import { useTranslation } from 'react-i18next';

const PlanTable = () => {
    const { t } = useTranslation();
    const active = UserService.currentPackage();
    // const [
    //     active,
    //     // setActive
    // ] = useState(currentPackage || 0);

    const plans = [
        {
            groupName: 'Cookies Consent Management',
            children: [
                {
                    title: 'Cookies Management',
                    children: [
                        { active: 1, name: IconCheck, icon: true },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Dashboard',
                    children: [
                        { active: 1, name: IconCheck, icon: true },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Banner Designer',
                    children: [
                        { active: 1, name: IconCheck, icon: true },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Cookie Scanner',
                    children: [
                        { active: 1, name: IconCheck, icon: true },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'PageView/Month',
                    sub: true,
                    children: [
                        { active: 1, name: '1,000,000' },
                        { active: 2, name: 'Unlimited' },
                        { active: 3, name: 'Unlimited' },
                        { active: 4, name: 'Unlimited' },
                    ],
                },
                {
                    title: 'Domain',
                    sub: true,
                    children: [
                        { active: 1, name: '5' },
                        { active: 2, name: 'Unlimited' },
                        { active: 3, name: 'Unlimited' },
                        { active: 4, name: 'Unlimited' },
                    ],
                },
            ],
        },
        {
            groupName: 'Data Inventory',
            children: [
                {
                    title: 'Activity Management',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },

                {
                    title: 'Data Flow',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'RoPA',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
            ],
        },
        {
            groupName: 'Privacy Policy',
            children: [
                {
                    title: 'Privacy Policy Template',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Form Designer',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
            ],
        },
        {
            groupName: 'Consent Management',
            children: [
                {
                    title: 'Dashboard',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Form Designer',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: IconCheck, icon: true },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
            ],
        },
        {
            groupName: 'Data Subject 360',
            children: [
                {
                    title: 'Workflow Management',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Dashboard',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'DPO Task Management',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Form Designer',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
                {
                    title: 'Email Template',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: IconCheck, icon: true },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
            ],
        },
        {
            groupName: 'Data Catalog',
            children: [
                {
                    title: 'Metadata Management',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: '-' },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },

                {
                    title: 'Data Labeling',
                    children: [
                        { active: 1, name: '-' },
                        { active: 2, name: '-' },
                        { active: 3, name: '-' },
                        { active: 4, name: IconCheck, icon: true },
                    ],
                },
            ],
        },
    ];

    const headers = [
        {
            title: 'Cookie Management',
            active: 1,
        },
        {
            title: 'PDPA Starter (15 GB)',
            active: 2,
        },
        {
            title: 'PDPA Professional (50 GB)',
            active: 3,
        },
        {
            title: 'Business Enterprise (100 GB)',
            active: 4,
        },
    ];

    return (
        <div className="my-12 bg-white shadow max-w-7xl m-auto rounded">
            <div className="grid grid-cols-6">
                <Affix className="affix">
                    <div className="grid grid-cols-6 bg-white">
                        <div style={Style.Border} className="col-span-2">
                            <div className="flex items-center justify-center">
                                <div className="w-56 py-2">
                                    <IconHeader />
                                </div>
                            </div>
                        </div>
                        {headers.map((header) => (
                            <div
                                key={header.title}
                                style={Style.Border}
                                className={classNames(
                                    'flex justify-center items-center flex-col',
                                    {
                                        'bg-[#F3FCF8]':
                                            active === header.active,
                                    }
                                )}
                            >
                                {header.active === active && (
                                    <div className="uppercase rounded-full w-max bg-success text-white px-4 mb-2">
                                        ACTIVE NOW
                                    </div>
                                )}
                                <span className="font-semibold">
                                    {header.title}
                                </span>
                                <div
                                    className={classNames(
                                        'bg-[#EDEEF9] whitespace-pre-line text-purple p-2 rounded mt-2 font-semibold text-center w-32',
                                        {
                                            'bg-success text-white':
                                                active === header.active,
                                        }
                                    )}
                                >
                                    {t('PricePlan.DescTable1')}
                                </div>
                            </div>
                        ))}
                    </div>
                </Affix>
                {plans.map((plan, index) => (
                    <Fragment key={index}>
                        <div className="col-span-7 p-4 bg-[#DFF3FC] font-semibold text-base">
                            {plan.groupName}
                        </div>
                        {plan.children.map((child, i) => (
                            <Fragment key={i}>
                                <div
                                    style={Style.Border}
                                    className={classNames(
                                        'col-span-2 flex items-center p-4',
                                        {
                                            'bg-purple-light text-purple':
                                                child.sub,
                                        }
                                    )}
                                >
                                    {child.sub && (
                                        <span className="ml-4 mr-2">•</span>
                                    )}
                                    <span>{child.title}</span>
                                </div>
                                {child.children.map((child_, i_) => (
                                    <div
                                        key={i_}
                                        style={Style.Border}
                                        className={classNames(
                                            'flex justify-center items-center p-4 text-center',
                                            {
                                                'bg-[#F3FCF8]':
                                                    active === child_.active,
                                            }
                                        )}
                                    >
                                        {child_.icon ? (
                                            <child_.name
                                                active={
                                                    active === child_.active
                                                }
                                            />
                                        ) : (
                                            <span>{child_.name}</span>
                                        )}
                                    </div>
                                ))}
                            </Fragment>
                        ))}
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

const Style = {
    Border: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#EDEEF9',
    },
    Shadow: {
        boxShadow: 'rgb(0 0 0 / 12%) 0px 10px 14px 0px',
    },
};

export default PlanTable;
